import React from 'react';
import type ProductsJsmChatopsAndVideoToolsType from '@atlassian/jira-spa-apps-products-jsm-chatops-and-video-tools/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmChatopsAndVideoTools = lazyForPaint<
	typeof ProductsJsmChatopsAndVideoToolsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-chatops-and-video-tools", jiraSpaEntry: "async-products-jsm-chatops-and-video-tools" */ '@atlassian/jira-spa-apps-products-jsm-chatops-and-video-tools'
		),
	),
);

const AsyncProductsJsmChatopsAndVideoTools = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmChatopsAndVideoTools}
		pageId="products-jsm-chatops-and-video-tools"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmChatopsAndVideoTools;
